import React from 'react';
import CommonParentLinkField from '@atlassian/jira-issue-create-commons/src/ui/parent-link-field/index.tsx';
import type { Props } from './types.tsx';

export const ParentLinkField = ({ useFormContext, ...commonParentLinkFieldProps }: Props) => {
	// eslint-disable-next-line react-hooks/react-compiler
	const [{ isEpicLinkSelected, selectedIssueType, requestBackedIssueType }] = useFormContext();

	return (
		<CommonParentLinkField
			{...commonParentLinkFieldProps}
			isEpicLinkSelected={isEpicLinkSelected}
			selectedIssueTypeLabel={requestBackedIssueType?.label ?? selectedIssueType?.label ?? ''}
			selectedIssueTypeId={requestBackedIssueType?.value ?? selectedIssueType?.value ?? ''}
		/>
	);
};
